<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="main">
				<div class="navbar">
					<img @dragstart.prevent src="@/assets/topLeftImg.png" alt="" class="logo" @click="toTopImg(0)" />
					<img @dragstart.prevent src="@/assets/002.png" alt="" class="search" />
					<img @dragstart.prevent src="@/assets/003.png" alt="" class="menu" @click="isMenuShow = true" />
				</div>
				<div class="navbar-placeholder"></div>
				<div class="banner" style="width: 100vw; height: 53.333333vw" v-if="count == 0">
					<el-carousel trigger="click" height="53.333333vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height: 53.333333vw">
							<img
								@dragstart.prevent
								:src="webImg + item.bannerImg + imgCut(1000, 530, 'r')"
								alt=""
								srcset=""
								style="width: 100vw;!important; height:53.333333vw;object-fit: fill;"
							/>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-if="$route.query.index == 1 || $route.query.index == 2 || $route.query.index == 4 || $route.query.index == 5 || $route.query.index == 6">
					<!-- {{ count }}
          {{ webImg + navBarList[count].frontImg }} -->
					<div style="width: 100vw; height: 45.066666vw">
						<img
							@dragstart.prevent
							v-if="navBarList[$route.query.index - 1] && navBarList[$route.query.index - 1].frontImg"
							:src="webImg + navBarList[$route.query.index - 1].frontImg + imgCut(1000, 450)"
							alt=""
							style="width: 100vw; height: 45.066666vw"
						/>
					</div>
				</div>
				<router-view />
				<div class="foot">
					<div class="footOne" v-if="count == 0">
						<div class="footOneItem" @click="footClick(0)">
							<img @dragstart.prevent src="../../src/assets/footOneImg1.png" alt="" />
							<div class="footText">公司概况</div>
						</div>
						<div class="footOneItem" @click="footClick(1)">
							<img @dragstart.prevent src="../../src/assets/footOneImg2.png" alt="" />
							<div class="footText">发展历程</div>
						</div>
						<div class="footOneItem" @click="footClick(2)">
							<img @dragstart.prevent src="../../src/assets/footOneImg3.png" alt="" />
							<div class="footText">资质荣誉</div>
						</div>
						<div class="footOneItem" @click="footClick(3)">
							<img @dragstart.prevent src="../../src/assets/footOneImg4.png" alt="" />
							<div class="footText">组织架构</div>
						</div>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg" />
					<div class="footFour">
						<div class="row-1" style="cursor: pointer">
							<a @click="copyrightClick()">版权声明</a>
							<div class="line">｜</div>
							<a @click="navBarClick(4)" style="cursor: pointer">联系我们</a>
						</div>
						<div class="row-2">版权所有:中国通用机械工程有限公司</div>
						<div>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:京ICP备19013757号-1</a>
							<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010521" style="margin-left: 10px">京公网安备11010202010521号</a>
						</div>
					</div>
					<div class="menu-modal" v-if="isMenuShow" @click="isMenuShow = false">
						<div class="menu-modal-content" @click.stop>
							<div class="header">
								<img @dragstart.prevent src="@/assets/home.png" alt="" class="home" @click="toTopImg(0)" />
								<div class="txt" @click="toTopImg(0)">首页</div>
								<div class="close" @click="isMenuShow = false"><i class="el-icon-close"></i></div>
							</div>
							<div class="menu-list">
								<div class="yiji-item" v-for="(item, index) in navBarList" :key="index">
									<div class="content" @click="navMouseEnter(index)">
										<img @dragstart.prevent src="@/assets/004.png" alt="" class="dot" />
										<div class="title">{{ item.menuName }}</div>
										<img @dragstart.prevent src="@/assets/006.png" alt="" class="arrow-down" v-if="index == enterCount" />
										<img @dragstart.prevent src="@/assets/005.png" alt="" class="arrow-right" v-else />
									</div>
									<div class="erji-item" v-if="enterCount == index" v-for="(item1, index1) in chooseList" @click.stop="chooseClick(index1)">
										<div class="txt" v-if="index != 2">{{ item1.menuName }}</div>
										<div class="txt" v-else>{{ item1.title }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="main">
				<div class="top1">
					<img src="../assets/topLeftImg.png" alt="" class="topLeftImg" @click="toTopImg(0)" @dragstart.prevent />
					<div class="top_right">
						<div class="top">
							<input type="text" placeholder="搜索" v-model="search" class="search" @keydown="searchInput($event)" />
						</div>
						<!-- @mouseleave="enterShow = false" -->
						<div
							class="navBar"
							@mouseleave="
								enterShow = false;
								enterCount = -1;
							"
						>
							<div class="navBarItem" @click="navBarClick(index)" @mouseenter.stop="navMouseEnter(index)" v-for="(item, index) in navBarList" :key="index">
								<div>{{ item.menuName }}</div>
								<template v-if="index != 2">
									<div class="choose" v-if="enterCount == index && enterShow" :class="{ choose1: chooseList.length == 1 }">
										<div
											@click.stop="chooseClick(index1)"
											class="chooseItem"
											:class="{ chooseItem1: chooseCount == index1 }"
											v-for="(item1, index1) in chooseList"
										>
											<span>{{ item1.menuName }}</span>
										</div>
									</div>
								</template>
								<template v-else>
									<div class="choose index2" v-if="enterCount == index && enterShow" :class="{ choose1: chooseList.length == 1 }">
										<div
											class="chooseItem-wrapper"
											v-for="(classificationItem, classificationIndex) in engineeringListClassification"
											:key="classificationIndex"
										>
											<div class="title">{{ classificationItem.title }}</div>
											<div class="list">
												<div
													@click.stop="chooseClick(index1, item1)"
													class="chooseItem"
													:class="{ chooseItem1: chooseCount == index1 }"
													v-for="(item1, index1) in classificationItem.list"
												>
													<span>{{ item1.title }}</span>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 100%; height: 5px; background: #0072c4"></div>
				<div class="banner" style="width: 100vw; height: 25.17vw" v-if="isActive('/home')">
					<el-carousel trigger="click" height="25.17vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height: 25.17vw">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1920, 251, 'r')" alt="" srcset="" style="width: 100vw;!important; height:25.17vw;" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-if="isActive('/aboutUs') || isActive('/newsCenter') || isActive('/construct') || isActive('/investor') || isActive('/contactUs')">
					<div style="width: 100vw; height: 25.17vw">
						<img
							@dragstart.prevent
							v-if="navBarList[$route.query.index - 1] && navBarList[$route.query.index - 1].frontImg"
							:src="webImg + navBarList[$route.query.index - 1].frontImg + imgCut(1000, 251, 'r')"
							alt=""
							style="width: 100vw; height: 25.17vw"
						/>
					</div>
				</div>
				<router-view />

				<div class="foot">
					<div class="footOne" v-if="count == 0">
						<div class="footOneItem" @click="footClick(0)">
							<img @dragstart.prevent src="../../src/assets/footOneImg1.png" alt="" />
							<div class="footText">公司概况</div>
						</div>
						<div class="footOneItem" @click="footClick(1)">
							<img @dragstart.prevent src="../../src/assets/footOneImg2.png" alt="" />
							<div class="footText">发展历程</div>
						</div>
						<div class="footOneItem" @click="footClick(2)">
							<img @dragstart.prevent src="../../src/assets/footOneImg3.png" alt="" />
							<div class="footText">资质荣誉</div>
						</div>
						<div class="footOneItem" @click="footClick(3)">
							<img @dragstart.prevent src="../../src/assets/footOneImg4.png" alt="" />
							<div class="footText">组织架构</div>
						</div>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg" />
					<div class="footThree">
						<div class="link">友情链接</div>
						<div style="margin-left: 40px">
							<el-select v-model="value" placeholder="相关单位" @change="change">
								<!-- <div v-infinite-scroll="load" style="overflow:auto;height: 100px;"> -->
								<el-option v-for="item in options" :key="item.id" :label="item.unitName" :value="item"></el-option>
								<!-- </div> -->
							</el-select>
						</div>
					</div>

					<div class="footFour">
						<div style="cursor: pointer">
							<a @click="copyrightClick()">版权声明</a>
							｜
							<a @click="navBarClick(4)" style="cursor: pointer">联系我们</a>
						</div>
						<div>版权所有:中国通用机械工程有限公司</div>
						<div>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:京ICP备19013757号-1</a>
							<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010521" style="margin-left: 10px">京公网安备11010202010521号</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { menu, bannerList, menuAll, businessList, unitList, unitBelowList } from '../api/api';

export default {
	name: 'mainTemplate',
	data() {
		return {
			bannerImgList: [],
			show: false,
			navBarList: [],
			count: 0,
			chooseCount: -1,
			options: [],
			optionsChildren: [],
			value: '',
			valueChildren: '',
			chooseList: [],
			unitBelowList: [],
			search: '',
			enterShow: false,
			enterCount: -1,
			isMenuShow: false,
			chooseMenuList: [
				[],
				[],
				[],
				[
					{
						menuName: '党建概况'
					},
					{
						menuName: '二十大专题'
					},
					{
						menuName: '党纪学习教育'
					}
				],
				[],
				[
					{
						menuName: '联系我们'
					}
				]
			],
			route: ['/aboutUs', '/newsCenter', '/vocational', '/construct', '/investor', '/contactUs'],
			engineeringList: [],
			engineeringListClassification: [
				{
					title: '环保工程',
					list: []
				},
				{
					title: '城市基础设施工程',
					list: []
				},
				{
					title: '能源工程',
					list: []
				},
				{
					title: '新型工业化建设及其他',
					list: []
				}
			]
		};
	},
	created() {
		this.$store.commit('changeScreenWidth');
		// 监听页面尺寸
		window.addEventListener('resize', () => {
			this.$store.commit('changeScreenWidth');
		});
		// 监听页面滚动
		window.onscroll = () => {
			// 发送滚动事件
			this.$bus.$emit('windowOnscroll');

			// 监听滚动到底部
			if (this.$global.reachBottom(0)) {
				console.log('滚动到底部了');
				this.$bus.$emit('reachBottom');
			}
		};

		if (this.$route.query.index) {
			this.count = this.$route.query.index;
		}

		this.getBannerList(); //首页轮播图
		this.getMenuAll(); //首页轮播图
		this.getUnitList(); //友情链接
		this.getUnitBelowList(); //友情链接
		console.log('this.count: ', this.count);
	},

	watch: {
		$route(to, from) {
			console.log(to.query.index, 'to');
			this.count = to.query.index;
			console.log('this.count: ', this.count);
		},
		isMenuShow(val) {
			console.log('val: ', val);
			this.$global.stopPageScroll(val);
		}
	},
	methods: {
		//首页轮播图
		getBannerList() {
			bannerList().then((res) => {
				console.log(res, 'res');
				this.bannerImgList = res.data;
			});
		},
		//首页链接
		toTopImg(index) {
			if (index == 0) {
				this.$router.push({
					path: '/home',
					query: {
						index: index
					}
				});
			} else {
				location.href = 'http://www.hgmri.com/';
			}
			this.isMenuShow = false;
		},
		//查询所有菜单
		getMenuAll() {
			menuAll().then((res) => {
				this.navBarList = res.data;
				console.log('this.navBarList: ', this.navBarList);

				for (let i = 0; i < this.navBarList.length; i++) {
					this.navBarList[i].route = this.route[i];
				}
				console.log(this.navBarList, 'this.navBarList');
				this.getMenu(0);
				this.getMenu(1);
				this.getMenu(4);
				this.getVocationalList();
			});
		},
		isActive(route) {
			return this.$route.path === route;
		},
		//鼠标移入
		navMouseEnter(index) {
			if (this.enterCount == index) {
				return (this.enterCount = -1);
			}
			this.enterCount = index;
			this.enterShow = true;
			console.log('this.chooseMenuList: ', this.chooseMenuList);
			this.chooseList = this.chooseMenuList[index];
		},
		//查询子菜单
		getMenu(index) {
			menu(this.navBarList[index].menuId).then((res) => {
				this.chooseMenuList[index] = res.data;
			});
		},
		getVocationalList() {
			businessList().then((res) => {
				this.chooseMenuList[2] = res.data;
				this.engineeringList = res.data;
				console.log('this.engineeringList: ', this.engineeringList);
				for (let i = 0; i < this.engineeringList.length; i++) {
					if (
						this.engineeringList[i].title == '市政污水' ||
						this.engineeringList[i].title == '农村污水' ||
						this.engineeringList[i].title == '工业废水' ||
						this.engineeringList[i].title == '污泥处置' ||
						this.engineeringList[i].title == '水体治理' ||
						this.engineeringList[i].title == '洒水除尘' ||
						this.engineeringList[i].title == '固体废弃物'
					) {
						this.engineeringListClassification[0].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].title == '城市供水' ||
						this.engineeringList[i].title == '轨道交通' ||
						this.engineeringList[i].title == '机场安检' ||
						this.engineeringList[i].title == '城市供热' ||
						this.engineeringList[i].title == '暖通工程' ||
						this.engineeringList[i].title == '智慧城市'
					) {
						this.engineeringListClassification[1].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].title == '电厂电站设备' ||
						this.engineeringList[i].title == '核电站气体存贮' ||
						this.engineeringList[i].title == '清洁能源' ||
						this.engineeringList[i].title == '新能源' ||
						this.engineeringList[i].title == '节能管理'
					) {
						this.engineeringListClassification[2].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].title == '工业工程' || 
						this.engineeringList[i].title == '其他工程' || 
						this.engineeringList[i].title == '数智工厂' || 
						this.engineeringList[i].title == '零碳园区' || 
						this.engineeringList[i].title == '数据中心' || 
						this.engineeringList[i].title == '石油化工' || 
						this.engineeringList[i].title == '医疗器械' || 
						this.engineeringList[i].title == '智慧农业'
						) {
						this.engineeringListClassification[3].list.push(this.engineeringList[i]);
					}
				}
			});
		},

		chooseClick(index, item = {}) {
			if (this.enterCount == 0) {
				console.log(this.navBarList[this.enterCount]);
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 1,
						num: index
					}
				});
			}
			if (this.enterCount == 1) {
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 2,
						num: index
					}
				});
			}
			if (this.enterCount == 2) {
				if (this.isMobile) {
					this.openUrl({
						path: '/vocational',
						query: {
							id: this.chooseList[index].id,
							index: 3
						}
					});
				} else {
					let i = this.chooseList.findIndex((v) => v.title == item.title);
					this.openUrl({
						path: '/vocational',
						query: {
							id: this.chooseList[i].id,
							index: 3
						}
					});
				}
			}
			if (this.enterCount == 3) {
				if (index == 0) {
					this.openUrl({
						path: '/construct',
						query: {
							parentId: this.navBarList[this.enterCount].menuId,
							index: 4
						}
					});
				} else if (index == 1) {
					window.open('http://www.hgmri.com/ddjs/ddesd/ ', '_blank');
				} else if (index == 2) {
					window.open('https://www.12371.cn/djxx/', '_blank');
				}
			}

			// if (this.enterCount == 4) {
			// 	if (index == 2) {
			// 		window.open('http://www.sse.com.cn/home/search/?webswd=600444', '_blank')
			// 	} else {
			// 		this.openUrl({
			// 			path: '/investor',
			// 			query: {
			// 				parentId: this.navBarList[this.enterCount].menuId,
			// 				index: 5,
			// 				num: index
			// 			}
			// 		})
			// 	}

			// }

			if (this.enterCount == 4) {
				this.openUrl({
					path: '/contactUs',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 5,
						num: index
					}
				});
			}
			this.isMenuShow = false;
		},
		//查询业务领域列表
		getBusinessList(inx) {
			this.openUrl({
				path: '/vocational',
				query: {
					id: this.chooseMenuList[2][inx].id,
					index: 3
				}
			});
		},
		searchInput(e) {
			if (this.search && e.keyCode == 13) {
				// this.openUrl({ path: '/search', query: { search: this.search } })
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[1].menuId,
						index: 2,
						num: 0,
						search: this.search
					}
				});
			}
		},

		//导航栏
		navBarClick(index) {
			if (index == 0) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[index].menuId,
						index: index + 1
					}
				});
			}
			if (index == 1) {
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[index].menuId,
						index: index + 1
					}
				});
			}
			if (index == 2) {
				this.getBusinessList(0);
			}

			if (index == 3) {
				this.openUrl({
					path: '/construct',
					query: {
						parentId: this.navBarList[index].menuId,
						index: index + 1
					}
				});
			}
			if (index == 4) {
				this.openUrl({
					path: '/contactUs',
					// query: {
					// 	parentId: this.navBarList[index].menuId,
					// 	index: index + 1
					// },
					query: {
						parentId: this.navBarList[index].menuId,
						index: index + 1,
						num: 0
					}
				});
			}
			// if (index == 4) {
			// 	this.openUrl({
			// 		path: '/investor',
			// 		query: {
			// 			parentId: this.navBarList[index].menuId,
			// 			index: index + 1
			// 		}
			// 	})
			// }
			// if (index == 5) {
			// 	this.openUrl({
			// 		path: '/contactUs',
			// 		query: {
			// 			parentId: this.navBarList[index].menuId,
			// 			index: index + 1
			// 		}
			// 	})
			// }
		},

		//友情链接
		getUnitList() {
			unitList().then((res) => {
				this.options = res.data;
			});
		},
		getUnitBelowList() {
			unitBelowList().then((res) => {
				this.optionsChildren = res.data;
			});
		},
		//底部链接
		change(e) {
			this.value = e.unitName;
			this.$confirm('是否打开链接')
				.then((_) => {
					this.done(e.unitLink);
				})
				.catch((_) => {});
		},
		done(e) {
			location.href = e;
		},
		//底部链接
		change1(e) {
			this.valueChildren = e.belowName;
			console.log(111111);
			this.$confirm('是否打开链接')
				.then((_) => {
					this.done(e.belowLink);
				})
				.catch((_) => {});
		},
		footClick(inx) {
			if (inx == 0) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[0].menuId,
						num: 2130,
						index: 1
					}
				});
			}
			if (inx == 1) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[0].menuId,
						num: 2132,
						index: 1
					}
				});
			}
			if (inx == 2) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[0].menuId,
						num: 2133,
						index: 1
					}
				});
			}
			if (inx == 3) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[0].menuId,
						num: 2131,
						index: 1
					}
				});

				// this.openUrl({
				// 	path: '/investor',
				// 	query: {
				// 		parentId: this.navBarList[4].menuId,
				// 		index: 5,
				// 		num: 0
				// 	}
				// })
			}
		},
		copyrightClick() {
			this.openUrl({
				path: '/copyright',
				query: {
					search: this.search,
					index: 0
				}
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #ffffff;

		.navbar {
			position: fixed;
			top: 0;
			z-index: 99;
			display: flex;
			align-items: center;
			width: 100%;
			height: 1.333333rem;
			background: #ffffff;

			.logo {
				margin-left: 0.266667rem;
				margin-right: auto;
				width: 5.573333rem;
				height: 0.586667rem;
			}

			.search {
				width: 0.493333rem;
				height: 0.493333rem;
			}

			.menu {
				margin-left: 0.706667rem;
				margin-right: 0.453333rem;
				width: 0.453333rem;
				height: 0.426667rem;
			}
		}

		.navbar-placeholder {
			width: 100%;
			height: 1.333333rem;
		}

		.foot {
			margin-top: auto;

			.footOne {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.613333rem;

				.footOneItem {
					margin-bottom: 0.266667rem;
					width: 9.466667rem;
					height: 3.2rem;
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						width: 100%;
						object-fit: cover;
					}

					.footText {
						position: absolute;
						font-size: 0.48rem;
						font-family: Microsoft YaHei-Bold, Microsoft YaHei;
						font-weight: bold;
						color: #ffffff;
					}

					.footOneMore {
						position: absolute;
						top: 0.266667rem;
						right: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 0.906667rem;
						height: 0.586667rem;
						background: #0175c2;

						a {
							font-size: 0.32rem;
							font-family: Microsoft YaHei-Regular, Microsoft YaHei;
							font-weight: 400;
							color: #ffffff;
							text-decoration: none;
						}
					}
				}
			}

			.footTwoImg {
				display: flex;
				width: 100%;
				height: 1.2rem;
			}

			.footFour {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 1.866667rem;
				background: #1e243c;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				div,
				a {
					font-size: 0.24rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #979fbf;
					text-decoration: none;
				}

				.row-1 {
					display: flex;
					align-items: center;

					.line {
						margin: 0 0.266667rem;
					}
				}

				.row-2 {
					margin: 0.1rem 0;
				}
			}
		}

		.menu-modal {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(#000000, 0.5);
			z-index: 99;

			.menu-modal-content {
				width: 8rem;
				height: 100%;
				margin-left: auto;
				background: #ffffff;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				overflow-y: auto;

				.header {
					display: flex;
					align-items: center;
					width: 100%;
					height: 2.4rem;

					.home {
						width: 0.4rem;
						height: 0.4rem;
						margin-left: 0.693333rem;
						margin-right: 0.293333rem;
					}

					.txt {
						margin-right: auto;
						font-size: 0.506667rem;
						font-family: PingFang SC-Bold, PingFang SC;
						font-weight: bold;
						color: #363b4c;
					}

					.close {
						display: flex;
						margin-right: 0.533333rem;

						.el-icon-close {
							font-size: 0.706667rem;
						}
					}
				}

				.menu-list {
					width: 100%;

					.yiji-item {
						width: 100%;

						.content {
							display: flex;
							align-items: center;
							position: relative;
							width: 100%;
							height: 1.333333rem;
							background-color: #ffffff;

							.dot {
								position: absolute;
								margin-left: 0.666667rem;
								width: 0.16rem;
								height: 0.16rem;
							}

							.title {
								margin-left: 1.013333rem;
								margin-right: auto;
								font-size: 0.453333rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363b4c;
							}

							.arrow-down {
								width: 0.373333rem;
								height: 0.32rem;
								margin-right: 0.453333rem;
							}

							.arrow-right {
								width: 0.32rem;
								height: 0.373333rem;
								margin-right: 0.453333rem;
							}
						}

						.erji-item {
							display: flex;
							align-items: center;
							width: 100%;
							height: 1.333333rem;
							background-color: #f7f7f7;

							.txt {
								margin-left: 1.013333rem;
								font-size: 0.4rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363b4c;
							}
						}
					}
				}
			}
		}
	}
}

.device-pc {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #ffffff;
	}

	.topLeftImg {
		width: 522px;
		height: 54px;
		cursor: pointer;
		padding-top: 40px;
	}

	.top1 {
		width: 1300px;
		// height: 84px;
		display: flex;

		.top_right {
			flex: 1;

			.top {
				width: 100%;
				// height: 84px;
				display: flex;
				// align-items: center;
				padding-top: 35px;
				justify-content: flex-end;

				.search {
					width: 225px;
					height: 36px;
					background: rgba(255, 255, 255, 0.2);
					border-radius: 18px 18px 18px 18px;
					border: 1px solid #0175c2;
					box-sizing: border-box;
					margin-left: auto;
					background: url(../assets/search.png) no-repeat 20px center;
					background-size: 19px 19px;
					padding-left: 50px;
					box-sizing: border-box;
				}
			}

			.navBar {
				width: 100%;
				// height: 68px;
				// background: red;
				padding-top: 28px;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				.navBarItem {
					width: 120px;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 18px;
					font-family: Microsoft YaHei-Bold, Microsoft YaHei;
					font-weight: bold;
					color: #333333;
					cursor: pointer;
					position: relative;
					margin-left: 50px;

					&:first-child {
						margin-left: 0px !important;
					}

					.choose1 {
						width: 120px !important;
					}

					.choose {
						// padding-top: 4px;
						min-width: 420px;
						// height: 100px;
						box-sizing: border-box;
						position: absolute;
						left: 0;
						top: 40px;
						z-index: 999999;
						background: #ffffff;
						display: flex;
						// flex-wrap: wrap;
						font-size: 18px;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #0072c4;

						&.index2 {
							display: flex;
							flex-direction: column;
						}

						.chooseItem-wrapper {
							display: flex;
							flex-direction: column;
							.title {
								color: #333;
								font-size: 18px;
								font-family: Microsoft YaHei-Bold, Microsoft YaHei !important;
								font-weight: bold;
								padding: 10px 20px;
							}
							.list {
								flex: 1;
								display: flex;
								flex-wrap: wrap;
							}
						}

						.chooseItem {
							// margin-right: 10px;
							// margin-top: 10px;
							padding: 10px 20px;
							border-bottom: 1px dashed #e5e5e5;
							border-top: 1px dashed #e5e5e5;

							span {
								// color: aqua;
								white-space: nowrap;
							}

							span:hover {
								text-decoration: underline;
							}
						}

						.chooseItem:last-child {
							// border-bottom: 1px dashed #e5e5e5;
						}

						.chooseItem1 {
							background: #0076be;
							color: #ffffff;
						}

						.chooseItem:hover {
							// background: #0076BE;
							// color: #FFFFFF;
						}
					}
				}

				.navBarItem:hover {
					background: #0076be;
					font-size: 16px;
					font-family: Microsoft YaHei-Bold, Microsoft YaHei;
					font-weight: bold;
					color: #ffffff;
				}

				.navBarItem1 {
					background: #0076be;
					font-size: 16px;
					font-family: Microsoft YaHei-Bold, Microsoft YaHei;
					font-weight: bold;
					color: #ffffff;
				}
			}
		}
	}

	.foot {
		width: 100vw;
		// background: #FFFFFF;

		.footOne {
			width: 1200px;
			height: 290px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			cursor: pointer;
			position: relative;

			.footOneMore {
				position: absolute;
				right: 30px;
				top: 60px;
				width: 43px;
				height: 28px;
				// background: #0175C2;
				background: rgba(1, 117, 194, 0.5);
				font-size: 14px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;

				a {
					color: #ffffff;
					text-decoration: none;
				}
			}

			.footOneItem {
				position: relative;
				width: 300px;
				height: 200px;
				// background: rgba(0, 0, 0, 0.5);
				overflow: hidden;
				margin-right: 30px;
				// filter: blur(1px) grayscale(.1);
				opacity: 0.6;
				// background: rgba(255, 255, 255, .6);

				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				// }
			}

			.footOneItem:hover {
				opacity: 2;
				// background: rgba(255, 255, 255, 1);

				// background: rgba(0, 0, 0, 1);

				// transform: scaleX(20%);
				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				//   transform: scale(1.1);
				// }
			}

			img {
				width: 270px;
				height: 200px;
			}

			.footText {
				font-size: 20px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.footTwoImg {
			width: 100vw;
			height: 140px;
		}

		.footThree {
			width: 1300px;
			height: 64px;
			display: flex;
			align-items: center;
			// justify-content: center;
			margin: 0 auto;

			.link {
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004ea1;
			}
		}

		.footFour {
			width: 100vw;
			height: 179px;
			background: #0076be;
			font-size: 14px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			line-height: 30px;

			a {
				color: #ffffff;
				text-decoration: none;
			}
		}
	}

	.banner {
		// @media screen and (min-width: 960px) and (max-width: 1200px) {
		//   zoom: .643;
		// }
	}

	.el-carousel__container {
		height: 25.17vw !important;
		height: 5.333333rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue